// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-narrow {
  max-width: var(--content-narrow);
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/profile/profile.page.scss"],"names":[],"mappings":"AACA;EACI,gCAAA;EACA,cAAA;AAAJ","sourcesContent":["\n.content-narrow {\n    max-width: var(--content-narrow);\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
